import { useBankLogo } from './useBankLogo';

type Props = {
  code: string | undefined | null;
  alt?: string;
  className?: string;
};

const BankLogo = ({ code, alt, className }: Props) => {
  const { src, hasLogo } = useBankLogo(code);
  if (!hasLogo) return null;
  return <img src={src} alt={alt ?? code ?? ''} className={className} />;
};

export default BankLogo;
